{
  "attachAria": "파일 첨부",
  "emptyHint": "문제를 설명해 주세요. 지원팀이 여기에서 답변합니다",
  "emptyTitle": "아직 메시지가 없습니다",
  "fileOpenAria": "첨부 파일 열기",
  "logAria": "문의 대화",
  "newMessages": "새 메시지",
  "placeholder": "메시지를 입력하세요…",
  "placeholderDisabled": "메시지를 일시적으로 사용할 수 없습니다",
  "previewAria": "첨부 파일 보기",
  "previewCloseAria": "미리보기 닫기",
  "removeAttachmentAria": "파일 삭제",
  "retry": "다시 시도",
  "screenshotAria": "스크린샷 찍기",
  "seen": "읽음",
  "sendAria": "메시지 보내기",
  "sendFailed": "메시지를 보내지 못했습니다",
  "sending": "보내는 중…",
  "student": "학생",
  "supportName": "Skyeng 지원팀",
  "today": "오늘",
  "yesterday": "어제",
  "you": "나"
}
